import React from 'react';
import ReactDOM from 'react-dom';

import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import './stylesApp.css';
import './stylesSlider.css';

import App from './App';

// import i18n (needs to be bundled ;)) 
import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));
